import { GamePhase, useGameStore } from '@stores'

import { LevelSelectionWagon } from './LevelSelectionWagon'
import { Locomotive } from './Locomotive'
import { TitleWagon } from './TitleWagon'
import { VehicleKinematicsDriver } from './VehicleKinematicsDriver'
import { Wagon } from './Wagon'

export function Vehicles() {
  const phase = useGameStore(state => state.phase)
  const network = useGameStore(state => state.network)
  const npcs = Array.from(network.npcs.values())

  return (
    <>
      <VehicleKinematicsDriver />

      {network.locomotive && <Locomotive id={network.locomotive.id} />}

      {npcs.map(npc => (
        <Locomotive key={npc.id} id={npc.id} />
      ))}

      {Array.from(network.wagons.values()).map((wagon, index) =>
        phase <= GamePhase.TITLE_TRANSITION ? (
          <group
            key={wagon.id}
            onDoubleClick={e => {
              e.stopPropagation()
              if (index > 0) return
              location.hash = 'debug'
            }}
          >
            <TitleWagon id={wagon.id} />
          </group>
        ) : phase <= GamePhase.LEVEL_SELECTION_TRANSITION ? (
          <LevelSelectionWagon key={wagon.id} id={wagon.id} />
        ) : (
          <Wagon key={wagon.id} id={wagon.id} color={wagon.color} />
        ),
      )}
    </>
  )
}
